export default {
    rubbers: [],
    rubbersLoading: false
}